import React from "react";
import "./ContextMenus.css";

/**
 * FreezeContextMenu
 * Right-click menu on a data cell — Freeze panes, Freeze top row,
 * Freeze first column, Unfreeze.  The currently-frozen row/col counts
 * decide which options are shown.
 *
 * Props:
 *   ctx              – { x, y, row, col } click coordinates + cell index
 *   frozenRows / frozenCols
 *   onFreeze         – (rows, cols) => void
 *   onUnfreeze       – () => void
 *   onClose          – () => void
 */
function FreezeContextMenu({ ctx, frozenRows, frozenCols, onFreeze, onUnfreeze, onClose }) {
  if (!ctx) return null;
  return (
    <>
      <div
        className="header-ctx-backdrop"
        onClick={onClose}
        onContextMenu={(e) => { e.preventDefault(); onClose(); }}
      />
      <div
        className="header-ctx-menu"
        style={{ left: ctx.x, top: ctx.y }}
        onClick={(e) => e.stopPropagation()}
      >
        {(frozenRows > 0 || frozenCols > 0) && (
          <button type="button" className="header-ctx-item" onClick={onUnfreeze}>
            <span className="material-icons header-ctx-icon">lock_open</span>
            Unfreeze Panes
          </button>
        )}
        <button
          type="button"
          className="header-ctx-item"
          onClick={() => onFreeze(ctx.row, ctx.col)}
          title={`Freeze ${ctx.row} row(s) and ${ctx.col} column(s)`}
        >
          <span className="material-icons header-ctx-icon">lock</span>
          Freeze Panes
        </button>
        {ctx.row !== 1 && (
          <button type="button" className="header-ctx-item" onClick={() => onFreeze(1, 0)}>
            <span className="material-icons header-ctx-icon">vertical_align_top</span>
            Freeze Top Row
          </button>
        )}
        {ctx.col !== 1 && (
          <button type="button" className="header-ctx-item" onClick={() => onFreeze(0, 1)}>
            <span className="material-icons header-ctx-icon">align_horizontal_left</span>
            Freeze First Column
          </button>
        )}
      </div>
    </>
  );
}

export default FreezeContextMenu;
